<template lang="pug">
    Tabs.cart-list
        el-card.contains-table(shadow="always")
            .error(v-if="error")
                template(v-if="error.code")
                    Error(:message="$t(error.message || 'Something went wrong!')" :code="error.code")
                template(v-else)
                    Error(:message="$t('Something went wrong!')" :code="501")
            .carts-table(v-else)
                //- :row-link-config="cartsPaginated.link"
                paginated-items(
                    scope="ex"
                    type="shop_cart"
                    :loading="loading"
                    :items="cartsPaginated.items"
                    :filters="filters"
                    :show-filters="showFilters"
                    :variables="cartsPaginated.variables"
                    :all-columns="cartsPaginated.allColumns"
                    :active-columns="cartsPaginated.activeColumns"
                    :page-info="cartsPaginated.pageInfo"
                    :sortables="sortables"
                    :sort="sort"
                    @pagination-size-change="handleSizeChange"
                    @pagination-current-change="handleCurrentChange"
                    @show-table-columns="handleColsShow"
                    @change-filter="handleFilterInputChange"
                    @click="handleClick"
                    @change-sort="handleSortInputChange"
                )
                    template(slot="top")
                        el-row.table-top(v-loading="loading" type="flex" justify="space-between")
                            .left
                                //- el-button(type="primary" size="mini" icon="el-icon-fa-plus fas" @click="addCart" :disabled="true")
                                //-     | {{ $t('New Cart') }}
                            .right.hide-on-empty
                                el-button(
                                    :type="includeGuests ? 'primary' : 'info'"
                                    size="mini"
                                    :icon="includeGuests ? 'el-icon-fa-eye far' : 'el-icon-fa-eye-slash far'"
                                    @click="toggleIncludeGuests"
                                )
                                    | {{ $t('Guest carts') }}
                                | &nbsp;
                                el-button(
                                    plain
                                    size="mini"
                                    type="primary"
                                    icon="el-icon-fa-filter fas"
                                    @click="toggleFilterVisiblity"
                                    :disabled="disable.showFilters || hasFilters"
                                )
                                    span(v-if="showFilters") {{ $t('Hide filters') }}
                                    span(v-else) {{ $t('Show filters') }}
                    template(v-slot:customer_name="{ item, value }")
                        template(v-if="value")
                            span {{ value }}
                        template(v-else-if="item.session_id")
                            el-tag(size="mini" type="info") {{ $t('Guest') }}
                        template(v-else)
                            span -
                    template(v-slot:tax_total="{ item, value }")
                        span {{ value | moneyFormat(getCurrency(item)) }}
                    template(v-slot:grand_total="{ item, value }")
                        span {{ value | moneyFormat(getCurrency(item)) }}
                    template(v-slot:actions="{ item }")
                        template(v-if="copyPasteShoppingCartsFeatureEnabled")
                            el-button.copy-button(
                                v-if="!copiedCart"
                                circle
                                size="mini"
                                type="info"
                                icon="el-icon-fa-copy far"
                                @click.stop.prevent="toggleCopyShoppingCart(item.id)"
                            )
                            el-button.copy-button(
                                v-else-if="parseInt(item.id) === parseInt(copiedCart)"
                                circle
                                size="mini"
                                type="default"
                                icon="el-icon-fa-clipboard fas"
                                @click.stop.prevent="toggleCopyShoppingCart(item.id)"
                            )
                            el-button.copy-button(
                                v-else
                                circle
                                size="mini"
                                type="primary"
                                icon="el-icon-fa-paste fas"
                                @click.stop.prevent="showCartClipboardModal(item)"
                            )

        el-dialog.overwrite-cart-dialog(
            :title="$t('Copy shopping cart')"
            :visible.sync="cartClipboardModal.visibility"
            :close-on-click-modal="false"
            top="10vh"
            width="520px"
            @closed="resetCartClipboardModal"
        )
            .body(v-loading="cartClipboardModal.loading")
                p {{ $t('Are you sure you want to overwrite this shopping cart?') }}
            template(slot="footer")
                el-button(
                    size="mini"
                    icon="el-icon-fa-times fas"
                    @click="cartClipboardModal.visibility = false"
                ) {{ $t('Dismiss') }}
                el-button(
                    :loading="cartClipboardModal.pasting"
                    size="mini"
                    type="danger"
                    icon="el-icon-fa-check fas"
                    @click="pasteShoppingCart"
                    :disabled="cartClipboardModal.pasting"
                ) {{ $t('Overwrite irreversible') }}
</template>

<i18n>
{
    "de": {
        "Guest": "Gast",
        "Guest carts": "Gast-Warenkörbe",
        "New Cart": "Neuer Warenkorb",
        "Show filters": "Filter anzeigen",
        "Hide filters": "Filter verbergen",
        "Cart list could not be fetched.": "Warenkorbliste konnte nicht abgerufen werden.",
        "Cart could not be fetched.": "Warenkorb konnte nicht abgerufen werden.",
        "Copy shopping cart": "Warenkorb kopieren",
        "Are you sure you want to overwrite this shopping cart?": "Soll dieser Warenkorb wirklich überschrieben werden?",
        "Shopping cart copied successfully!": "Warenkorb wurde erfolgreich kopiert",
        "Shopping cart pasted successfully!": "Warenkorb wurde erfolgreich eingefügt",
        "Shopping cart removed from clipboard!": "Warenkorb aus dem Zwischenspeicher entfernt",
        "Overwrite irreversible": "Unwiderruflich überschreiben"
    }
}
</i18n>

<script>
import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo'

import router from '@/router'
import pinia from '@/pinia';
import { useAuthStore, useSetupStore, useShopCartStore } from '@/stores';

import CartApi from '@/extensions/shop/store/api/cart';
import PaginatedItems from '@/components/PaginatedItems'
import Tabs from '@/extensions/shop/views/Partials/SalesTabs'
import Error from '@/components/Error'

export default {
    name: 'Carts',
    data() {
        return {
            error: false,
            cartClipboardModal: {
                pasting: false,
                visibility: false,
                item: undefined,
            },
            disable: {
                showFilters: false,
            },
            sortables: [
                'id',
                'created_at',
                'updated_at'
            ]
        }
    },
    components: {
        PaginatedItems,
        Error,
        Tabs
    },
    watch: {
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true)
            if (reload) this.initialize()
        },
    },
    computed: {
        user() {
            return useAuthStore().user;
        },
        includeGuests() {
            var key = 'ex:shop_cart:include_guests';
            var misc = _.get(this.user, 'settings.misc') || [];
            var setting = misc.find(function (item) { return item && item.key === key; });
            var value = _.get(setting, 'value') || 'false';
            return value === 'true';
        },
        copyPasteShoppingCartsFeatureEnabled() {
            let features = _.get(this.activeCms, 'config.template.features') || [];
            return !!features.find(el => el === 'copy-paste-shopping-carts');
        },
        showFilters() {
            return this.hasFilters || _.get(this.cartsPaginated, 'showFilters') || false
        },
        hasFilters() {
            return !_.isEmpty(this.filters)
        },
        filters() {
            let filters = _.cloneDeep(this.cartsPaginated.filters)
            delete filters.shop
            delete filters.hide_guests
            return filters
        },
        sort() {
            let cartsPaginated = _.cloneDeep(this.cartsPaginated.variables);
            let order, direction;
            if (cartsPaginated.order !== undefined && cartsPaginated.order !== '') order = cartsPaginated.order;
            else order = 'id';

            if (cartsPaginated.direction !== undefined && cartsPaginated.direction !== '') direction = cartsPaginated.direction;
            else direction = 'desc';

            return { field: order, direction };
        },
        activeShop() {
            return this.activeCms.shop
        },
        copiedCart() {
            const context = `cms:${this.activeCms.id}`
            return _.get(this.clipboard, `${context}.cart`);
        },
        setupStore() {
            return useSetupStore(pinia);
        },
        cartStore() {
            return useShopCartStore(pinia);
        },
        loading() {
            return this.cartStore.loading;
        },
        cartsPaginated() {
            return this.cartStore.cartsPaginated;
        },
        activeCms() {
            return this.setupStore.activeCms;
        },
        enabledExtensions() {
            return this.setupStore.enabledExtensions;
        },
        clipboard() {
            return this.setupStore.clipboard;
        },
        debounce() {
            return this.setupStore.debounce;
        }
    },
    methods: {
        toggleIncludeGuests() {
            var key = 'ex:shop_cart:include_guests';
            var value = !this.includeGuests;
            this.updateLoading(true);
            this.saveMiscSettings({ key, value: value.toString() })
                .then(this.refetch);
        },
        toggleCopyShoppingCart(id) {
            if (parseInt(id) === parseInt(this.copiedCart)) {
                this.removeFromClipboard('cart');

                this.$notify.warning({
                    title: this.$t('Shopping cart removed from clipboard!'),
                    iconClass: 'far el-icon-fa-clipboard',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 6000
                });
            } else {
                this.setClipboard({ key: 'cart', value: parseInt(id) });

                this.$notify.success({
                    title: this.$t('Shopping cart copied successfully!'),
                    iconClass: 'fas el-icon-fa-copy',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 6000
                });
            }
        },
        async pasteShoppingCart() {
            this.cartClipboardModal.pasting = true;
            await CartApi.fetchCartWithArticlePivots(this.copiedCart, this.activeCms.shop.id)
                .then(cart => {
                    this.cartClipboardModal.item.articlePivots = cart.articlePivots.map(el => {
                        return {
                            article: el.article,
                            propertyValueOptions: el.propertyValueOptions,
                            qty: el.qty
                        };
                    });
                })
                .catch(error => {
                    console.error(error);
                    this.cartClipboardModal.pasting = false;

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Cart could not be fetched.'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                });

            if (_.get(this.cartClipboardModal.item, 'articlePivots.length')) {
                CartApi.save(this.cartClipboardModal.item)
                    .then(() => {
                        this.resetCartClipboardModal();
                        this.removeFromClipboard('cart');

                        this.$notify.success({
                            title: this.$t('Shopping cart pasted successfully!'),
                            iconClass: 'fas el-icon-fa-paste',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 6000
                        });

                        this.updateLoading(true)
                        this.refetch()
                    })
                    .catch(error => {
                        console.error(error);
                        this.cartClipboardModal.pasting = false;

                        this.$notify.error({
                            title: this.$t('An error occurred!'),
                            message: this.$t('Cart could not be saved.'),
                            iconClass: 'fas el-icon-fa-xmark',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000,
                        })
                    });
            }
        },
        showCartClipboardModal(item) {
            this.cartClipboardModal.visibility = true;
            this.cartClipboardModal.item = item;
        },
        resetCartClipboardModal() {
            this.cartClipboardModal = {
                pasting: false,
                visibility: false,
                item: undefined,
            }
        },
        initialize() {
            if (!this.enabledExtensions.includes('shop')) {
                this.updateLoading(true)
                return
            }

            this.updateLoading(true)
            this.refetch()
        },
        getCurrency(item) {
            return _.get(item, 'customer.customerGroup.currency.iso4217')
                || _.get(this.activeCms, 'shop.defaultCustomerGroup.currency.iso4217')
        },
        addCart() {
            // TODO
            // open stepper modal

            // const params = { id: 'new' }
            // router.push({ name: 'cart-main', params })
        },
        handleClick(item) {
            const params = { id: item.id }
            router.push({ name: 'cart-main', params })
        },
        handleSizeChange(itemsPerPage) {
            this.updateLoading(true)
            this.defineItemsPerPage(itemsPerPage)
            this.refetch()
        },
        handleCurrentChange(currentPage) {
            this.updateLoading(true)
            this.defineCurrentPage(currentPage)
            this.refetch()
        },
        handleColsShow(visibleColumns) {
            this.defineActiveColumns(visibleColumns)
            // apolloClient.cache.reset()
            apolloClient.clearStore()
        },
        handleFilterInputChange(key, value, debounce = true) {
            this.defineFilterValue({ key, value })
            if (debounce) this.debouncedRefetch()
            else this.refetch()
        },
        handleSortInputChange(key, value) {
            this.defineSort({ key, value });
            this.refetch();
        },
        toggleFilterVisiblity() {
            const visible = this.showFilters

            let value = false
            if (!visible) value = true

            this.disable.showFilters = true
            this.defineFilterVisibility(value)
            this.saveFilterVisibility({ scope: 'ex', key: 'shop_cart', value })
                .finally(() => this.disable.showFilters = false)
        },
        refetch() {

            // always add the cms id to filters
            const shopID = this.activeShop.id
            const filter = {
                key: 'shop',
                match: shopID,
            }
            this.defineFilterValue({ key: 'shop', value: filter })

            if (!this.includeGuests) {
                this.defineFilterValue({ key: 'hide_guests', value: { key: 'hide_guests', match: true } })
            } else {
                this.defineFilterValue({ key: 'hide_guests', value: { key: 'hide_guests', match: '', like: '', from: '', to: '', in: [] } })
            }

            this.fetchCartsPaginated()
                .then(() => this.updateLoading(false))
                .catch(err => {
                    const { graphQLErrors } = err

                    let code = 501;
                    let message = 'An error occurred!';

                    if (graphQLErrors) {
                        code = _.get(graphQLErrors, '0.code') || code;
                        message = _.get(graphQLErrors, '0.message') || message;
                    }

                    let notify = true;
                    switch (code) {
                        case 401:
                            notify = false;
                            this.error = { code, message: 'You are not authorized' };
                            break;
                        case 403:
                            notify = false;
                            this.error = { code, message: 'You are not allowed to be here' };
                            break;
                        // case 404:
                        //     break;
                        default:
                            this.error = true;
                            break;
                    }

                    if (notify) {
                        this.$notify.error({
                            title: this.$t(message),
                            message: this.$t('Cart list could not be fetched.'),
                            iconClass: 'fas el-icon-fa-xmark',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }

                    this.updateLoading(false);

                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);
                })
        },
        debouncedRefetch: _.debounce(function () { // function scope is needed here
            this.updateLoading(true)
            this.refetch()
        }, useSetupStore(pinia).debounce || 300),
        updateLoading(value) {
            this.cartStore.updateLoading(value);
        },
        defineItemsPerPage(value) {
            this.cartStore.defineItemsPerPage(value);
        },
        defineCurrentPage(value) {
            this.cartStore.defineCurrentPage(value);
        },
        defineActiveColumns(value) {
            this.cartStore.defineActiveColumns(value);
        },
        defineFilterValue(payload) {
            this.cartStore.defineFilterValue(payload);
        },
        defineFilterVisibility(value) {
            this.cartStore.defineFilterVisibility(value);
        },
        defineSort(payload) {
            this.cartStore.defineSorting(payload);
        },
        fetchCartsPaginated() {
            return this.cartStore.fetchCartsPaginated();
        },
        saveFilterVisibility(payload) {
            return this.setupStore.saveFilterVisibility(payload);
        },
        setClipboard(payload) {
            return this.setupStore.setClipboard(payload);
        },
        removeFromClipboard(key) {
            return this.setupStore.removeFromClipboard(key);
        },
        saveMiscSettings(payload) {
            return this.setupStore.saveMiscSettings(payload);
        }
    },
    mounted() {
        this.initialize()
    },
}
</script>

<style lang="sass" scoped>
.overwrite-cart-dialog::v-deep .el-dialog__body
    display: none

.error
    padding: 20px
</style>
